import BackendService from './BackendService';

export default class DealerDataRevisionService {
  static getRevisions(dealerId, params) {
    return BackendService.get(`/dealerDataRevisions/${dealerId}`, { params });
  }
}
